import React from "react";
import { Box, Container, Typography, IconButton, Link } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer: React.FC = () => {
  return (
    <Box
      id="section-footer"
      sx={{ py: 4, bgcolor: "#333", color: "white", textAlign: "center" }}
    >
      <Container>
        <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
          ourixilva@gmail.com
        </Typography>
        <Box sx={{ "& > *": { mx: 1 } }}>
          <Link
            href="https://twitter.com/pauloouriques"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <IconButton color="inherit">
              <TwitterIcon />
            </IconButton>
          </Link>
          <Link
            href="https://www.facebook.com/paulo.ouriques"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <IconButton color="inherit">
              <FacebookIcon />
            </IconButton>
          </Link>
          <Link
            href="http://www.youtube.com/user/ourixilva"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <IconButton color="inherit">
              <YouTubeIcon />
            </IconButton>
          </Link>
          <Link
            href="https://www.linkedin.com/in/pauloouriques"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <IconButton color="inherit">
              <LinkedInIcon />
            </IconButton>
          </Link>
          <Link
            href="https://www.instagram.com/paulo.ouriques/"
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <IconButton color="inherit">
              <InstagramIcon />
            </IconButton>
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
